import './index.css'

interface BannerMessageProps {
  message: string
  type?: 'err' | 'info' | 'warn'
}

export default function BannerMessage({ message, type = 'info' }: BannerMessageProps) {

  return (<>
    <div className={`banner-message-box banner-message-box__${type}`}>
      <span className={`banner-message-text-${type}`}>{message}</span>
    </div>
  </>)

}